<template>
  <a-tag v-if="text !== undefined && text !== null" :color="get_tag_color_by_slots(column, text)">
    {{ column['field_' + text] }}
  </a-tag>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { get_tag_color_by_slots } from '@/utils/function';
export default defineComponent({
  name: 'Cell_custom',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: true,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
  setup() {
    return {
      get_tag_color_by_slots,
    };
  },
});
</script>
